<template>
	<Bar 
    		ref="chart"
    		:data="computedData"
    		:options="chartOptions"
    		:plugins="plugins"
    	/>
</template>

<script>
import moment from 'moment'
import colorLib from '@kurkle/color';
import { Bar } from 'vue-chartjs'
import { 
		Utils, 
		Chart, 
		ArcElement, 
		LineController, 
		LineElement, 
		BarController, 
		BarElement, 
		PieController, 
		RadarController, 
		PointElement, 
		LinearScale, 
		RadialLinearScale, 
		CategoryScale, 
		TimeSeriesScale, 
		Title, 
		Legend, 
		Filler, 
		Tooltip 
	} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.register(LineController, ArcElement, LineElement, BarController, BarElement, PieController, RadarController, PointElement, LinearScale, RadialLinearScale, CategoryScale, TimeSeriesScale, Title, Legend, Filler, Tooltip, ChartDataLabels);

export default {
	name: 'BarLineChart',
	components: {
		Bar
	},
	props: {
		data: {
			type: Object,
			default: {}
		},
		options: {
			type: Object,
			default: {}
		},
		plugins: {
			type: Array,
			default: []
		},
		chartData: {
			type: Object,
			default: {
				options: {

				}
			}
		},
		tooltipDefaultConfig: Object,
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	},
	data() {
		return {
			cdOptions: this.chartData.options,
			formats: { 
                day: this.chartData.options.period.format['day'],
                week: this.chartData.options.period.format['week'],
                month: this.chartData.options.period.format['month'],
                year: this.chartData.options.period.format['year'],
            }
		}
	},
	computed: {
        minDate() {
            return new Date(this.chartData.options.minDate * 1000)
        },
        maxDate() {
            return new Date(this.chartData.options.maxDate * 1000)
        },
		computedData() {
			if ( ! this.hasData ) {
				let data = JSON.parse(JSON.stringify(this.data));
				data.datasets = [
							{
								label: this.feTheme.charts_no_data_text,
								data: [1, 2, 3, 4, 2, 0],
								borderColor: '#c1d2c1',
			                    backgroundColor: '#d1d1d1',
							}
						]
				data.labels = ['', '', '', '', '', '']
				return data
			}

			this.chartData.data.datasets == null || this.chartData.data.datasets.length == 0 || this.chartData.data.datasets.map( el => {
					// console.log('el::', el)
					if ( el.type == 'bar' ) {
						el.backgroundColor = this.transparentize(el.backgroundColor, .5)
					}

					return el
				})
			return this.chartData.data
		},
	
		chartOptions() {
			const _this = this,
				cdOptions = this.cdOptions

			const scalesConfig = {
					x: {
						type : 'time',
						min: this.minDate,
						max: this.maxDate,
						time : {
							unit: cdOptions.period.unit,
							round: cdOptions.period.unit,
							// displayFormats: _.bind( _this.chartDisplayFormat, {options} )
						},

						ticks: {
							callback: function( value ) {
								if ( ! value ||  value < 0 ) return ''
								let tickLabel = this.format(value, _this.formats[cdOptions.period.unit] )
								if ( 'week' == cdOptions.period.unit ) {
									return `W${tickLabel}`
								} else {
									return tickLabel
								}
							}
						}
					},
					y: {
						beginAtZero: cdOptions.min ? false : true,
						suggestedMax: cdOptions.max,
						suggestedMin: cdOptions.min,
						grid: {
							tickLength: 10,
							drawOnChartArea: true,
						},
						ticks: {
							stepSize: cdOptions.step_size_y ? cdOptions.step_size_y : 5,
							precision: 0,
						}

					}

				}

			return {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					// position: 'right',
				},
				plugins: {
					tooltip: {
						..._this.tooltipDefaultConfig,
						callbacks: {
							title: function(context){
								return _this.tooltipTitleCallback( context, this )
							}, 
						}
					},
					datalabels: {
						display: false,
					},
				},
				scales: scalesConfig
			}
		}
	},
	methods: {
		displayFormats() {
			return this.displayFormats
		},
		tooltipTitleCallback(context, a) {
			if ( this.chartData.options.period ) {
				let unit = this.chartData.options.period.unit		
				return `${'week' == unit ? 'W' : ''}${moment(new Date(context[0].raw.x))
					.format(
						this.formats[unit].replaceAll('y', 'Y')
					)}`
			}
		},
		transparentize(value, opacity) {
			var alpha = opacity === undefined ? 0.5 : 1 - opacity;
			return colorLib(value).alpha(alpha).rgbString();
		}
	}
}
</script>